import { both, gt } from 'ramda';

import isNumber from './isNumber';

/**
 * Checks if value is a negative `Number` primitive or object. Zero is not considered neither
 * positive or negative.
 *
 * @func isNegative
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.15.0|v1.15.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isPositive|isPositive}
 * @example
 *
 * RA.isNegative(-1); // => true
 * RA.isNegative(Number.MIN_VALUE); // => false
 * RA.isNegative(+Infinity); // => false
 * RA.isNegative(NaN); // => false
 * RA.isNegative('5'); // => false
 */
var isNegative = /*#__PURE__*/both(isNumber, /*#__PURE__*/gt(0));

export default isNegative;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isNegative.js
// module id = 744
// module chunks = 0